import './BReportHero.css';

interface BReportHeroProps {
  title: string;
  subtitle?: string;
  description?: string;
  genres?: string[];
  era?: string;
  location?: string;
  keySound?: string;
  onGoDeeper?: () => void;
}

/**
 * Hero section with black background, title, and ghosted location text.
 */
export function BReportHero({
  title,
  subtitle,
  description,
  genres,
  era,
  location,
  keySound,
  onGoDeeper,
}: BReportHeroProps) {
  // Extract first word for ghosted background text
  const ghostText = location?.split(',')[0]?.toUpperCase() || '';

  return (
    <section className="b-report-hero">
      {/* Ghosted location text in background */}
      {ghostText && (
        <div className="b-report-hero__ghost" aria-hidden="true">
          {ghostText}
        </div>
      )}

      <div className="b-report-hero__content">
        <div className="b-report-hero__left">
          <p className="b-report-hero__label">
            <span className="b-report-hero__label-line" />
            Genre Report
          </p>
          <h1 className="b-report-hero__title">
            {/* Split title on & or : for multi-line effect */}
            {title.split(/(&|:)/).map((part, i) => (
              <span
                key={i}
                className={part === '&' || part === ':' ? 'b-report-hero__title-accent' : ''}
              >
                {part}
              </span>
            ))}
          </h1>
          {subtitle && (
            <p className="b-report-hero__subtitle">{subtitle}</p>
          )}
        </div>

        <div className="b-report-hero__right">
          {description && (
            <p className="b-report-hero__description">{description}</p>
          )}

          <dl className="b-report-hero__meta">
            {genres && genres.length > 0 && (
              <div className="b-report-hero__meta-item">
                <dt>Genre</dt>
                <dd>{genres.join(' · ')}</dd>
              </div>
            )}
            {era && (
              <div className="b-report-hero__meta-item">
                <dt>Era</dt>
                <dd>{era}</dd>
              </div>
            )}
            {location && (
              <div className="b-report-hero__meta-item">
                <dt>Location</dt>
                <dd>{location}</dd>
              </div>
            )}
            {keySound && (
              <div className="b-report-hero__meta-item">
                <dt>Sound</dt>
                <dd>{keySound}</dd>
              </div>
            )}
          </dl>

          {onGoDeeper && (
            <button className="b-report-hero__go-deeper" onClick={onGoDeeper}>
              Go Deeper
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 5v14M5 12l7 7 7-7" />
              </svg>
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
